import {Component, ElementRef, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ApiService} from 'src/app/shared/services/api.service';
import {PaymentService} from 'src/app/shared/services/payment.service';

@Component({
  selector: 'app-zimswitch',
  templateUrl: './zimswitch.component.html',
  styleUrl: './zimswitch.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ZimswitchComponent {
  otpRequested = false;
  private iframeObserver: MutationObserver | null = null;
  private globalObserver: MutationObserver | null = null;

  constructor(private api: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ZimswitchComponent>,
    private payment: PaymentService,
    private elementRef: ElementRef) {}

  ngOnInit() {
    this.setupPaymentForm();
  }

  ngAfterViewInit() {
    this.observeIframeAppearance();
  }

  ngOnDestroy() {
    this.cleanupObservers();
  }

  private setupPaymentForm(): void {
    const form = document.getElementById('payment-form') as HTMLFormElement;
    form.method = 'POST';
    form.action = `${this.api.env.baseUri}payments/validate/mnta`;
    form.target = '_top';
    form.className = 'paymentWidgets';
    form.dataset.brands = 'PRIVATE_LABEL';
    const script = document.createElement('script') as HTMLScriptElement;
    script.src = `${this.api.env.production ? 'https://eu-prod.oppwa.com' : 'https://eu-test.oppwa.com'}/v1/paymentWidgets.js?checkoutId=${this.data.id}`;
    script.crossOrigin = 'anonymous';
    form.parentNode?.appendChild(script);
  }

  private observeIframeAppearance(): void {
    this.globalObserver = new MutationObserver(() => {
      const iframe = this.elementRef.nativeElement.querySelector('iframe.wpwl-target') as HTMLIFrameElement;
      if(iframe) {
        this.globalObserver?.disconnect();
        this.globalObserver = null;
        this.observeIframeAttributes();
      }
    });

    this.globalObserver.observe(this.elementRef.nativeElement, {
      childList: true,
      subtree: true
    });
  }

  private observeIframeAttributes(): void {
    const iframe = this.elementRef.nativeElement.querySelector('iframe.wpwl-target') as HTMLIFrameElement;
    if(!iframe) {
      return;
    }
    this.iframeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if(mutation.type === 'attributes') {
          this.otpRequested = true;
        }
      });
    });
    this.iframeObserver.observe(iframe, {attributes: true});
  }

  private cleanupObservers() {
    if(this.globalObserver) {
      this.globalObserver.disconnect();
      this.globalObserver = null;
    }
    if(this.iframeObserver) {
      this.iframeObserver.disconnect();
      this.iframeObserver = null;
    }
  }

  closeModal() {
    this.payment.cleanupExistingPayments();
    this.dialogRef.close();
  }
}